// Areascontrolcambios.actions.ts

import { useMutation, useQuery, useQueryClient  } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseMutationsParams , AlertSeverityEnum} from '@/shared/interfaces';
import { erpApi } from "@/shared/axios";
import { toApiError } from "@/shared/utils/general";
import { useUiStore } from '@/store/ui';
import { NavigateFunction } from 'react-router-dom';
import { getUrlParamsFetch, handleAxiosError } from '@/shared/utils';
import { urlBackend } from "@/shared/constants";
// import { Areascontrolcambios, AreascontrolcambiosForm, AreascontrolcambiosPagingResp, AreascontrolcambiosParams } from "../interfaces/erp/controlcambios/areascontrolcambios.interface";
import { AreascontrolcambiosParams, AreascontrolcambiosPagingResp,  AreascontrolcambiosForm, Areascontrolcambios } from '@/erp/controlcambios/areascontrolcambios/types/areascontrolcambios.interface';
const { get, post, put, patch } = erpApi();

// get
const BASE_URL_CAMBIOS = `${urlBackend}api/v1/cambios/areas`;


export const useFetchGetAreascontrolcambios = (
  params?: AreascontrolcambiosParams,
  enabled = true
) => {
  return useQuery({
    queryKey: ['areascontrolcambios', ...Object.values(params ?? {})],
    queryFn: async () => {return getAreascontrolcambios(params)},
    enabled,
  });
};

export const getAreascontrolcambios = async (
  params?: AreascontrolcambiosParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return (await get<AreascontrolcambiosPagingResp>(`${urlBackend}api/v1/cambios/areas?${queryParams}`, true)) as unknown as AreascontrolcambiosPagingResp;
};

// // create

export const useFetchPostAreascontrolcambios = ({
  returnUrl,
  navigate,
  enableSuccessAlert = true,
  customSuccessMessage
  
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setAlerta = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: (data: AreascontrolcambiosForm) => {
      return postAreascontrolcambios(data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['areascontrolcambios']
      });

      navigate && returnUrl && navigate(returnUrl);

      // toast.success(data.message);
      enableSuccessAlert &&
        setAlerta &&
        setAlerta(
          true,
          customSuccessMessage ?? 'Area creada correctamente',
          AlertSeverityEnum.success
        );

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postAreascontrolcambios = async (data: AreascontrolcambiosForm) => {
  return await post<Areascontrolcambios>(`${urlBackend}api/v1/cambios/areas`, data, true);
};

// // filter by id

export const useFetchGetByIdAreascontrolcambios = (areaId: string) => {
  return useQuery({
    queryKey: ['areascontrolcambios', areaId],
    queryFn: async () => {
      return getByIdAreascontrolcambios(areaId);
    },
    refetchOnWindowFocus: false,
  });
};

export const getByIdAreascontrolcambios = async (areaId: string) => {
  const res = await get<Areascontrolcambios>(`${urlBackend}api/v1/cambios/areas/${areaId}`, true);
  return res;
};

// // update

export const useFetchPutAreascontrolcambios =  (navigate:NavigateFunction, returnUrl:string) => {

    const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlerta = useUiStore.getState().setAlert;

  return useMutation({
      mutationFn: putAreascontrolcambios,
      onSuccess: () =>{
        queryClient.invalidateQueries({queryKey: ['areascontrolcambios']});
        setAlerta(true, 'Area actualizada correctamente', AlertSeverityEnum.success);
        navigate(returnUrl);
      },
      onMutate: () =>{
        setIsGlobalLoading(true)
      },
      onSettled: () =>{
        setIsGlobalLoading(false)
      },
      onError: error =>{
        handleAxiosError(error)
      }
  });
};


export const putAreascontrolcambios = async ({
  id,
  data
}: {
  id: string;
  // data será todo lo del formulario MENOS el id
  data: Omit<AreascontrolcambiosForm, 'areaId'>;
}) => {
  return put<Areascontrolcambios>(`${urlBackend}api/v1/cambios/areas/${id}`, data, true);
};

// // eliminar (soft-delete: el backend de areas no tiene DELETE, solo PATCH /estado)

export const useFetchDeleteAreascontrolcambios = () => {
  const queryClient = useQueryClient();
  const setAlerta = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: (id: string) => desactivarAreascontrolcambios(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areascontrolcambios'] });
      setAlerta(true, 'Área desactivada correctamente', AlertSeverityEnum.success);
    },
    onError: (error) => toast.error(toApiError(error).message),
  });
};

export const desactivarAreascontrolcambios = async (id: string) => {
  return patch<Areascontrolcambios>(
    `${urlBackend}api/v1/cambios/areas/${id}/estado`,
    { activo: false },
    true
  );
};

//activo o inactivo
export const patchEstadoArea = async ({ id, activo }: { id: string; activo: boolean }) =>
  await patch(`${BASE_URL_CAMBIOS}/${id}/estado`, {activo}, true);

export const useFetchPatchEstadoArea = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchEstadoArea,
    onSuccess: () => {
      toast.success("Estado del area actualizado");
      queryClient.invalidateQueries({ queryKey: ["areascontrolcambios"] });
    },
    onError: (error) => toast.error(toApiError(error).message),
  });
};